export const EXTERNAL_LINKS = {
    PARTNER_RESOURCES: {
        title: 'Partner Resources',
        to: 'https://www.soloprotect.com/'
    }
} as const;